<template>
    <div class="d-flex align-items-center lifetime-guarantee" data-bs-custom-class="lg-tooltip" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top" data-bs-trigger="click" title='<div class="p-2 text-start"><b>Lifetime Guarantee</b><p class="mb-0">All our tyres come with a Lifetime Guarantee, free of charge!</p><a href="/lifetime-tyre-guarantee" class="text-primary fw-bold" title="More Information">More information</a></div>'>
        <i class="fa-solid fa-shield-check me-2 fa-md text-primary"></i>
        <p class="mb-0 cursor-pointer">Lifetime Guarantee</p>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.lg-tooltip {
    z-index: 111;
}
.lifetime-guarantee {
    p {
        font-size: 14px;
    }
}
</style>